export default {
  VUE_APP_BASE_URL: process.env.VUE_APP_BASE_ROUTE || "http://localhost:8090/",
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL || "https://localhost:44360/",
};
